<template>
  <router-view />
</template>

<script setup lang="ts">
import { onMounted } from 'vue'

onMounted(() => {
  // 应用初始化逻辑
})
</script>
<style lang="scss">
#app {
  min-height: 100vh;
  background: #f5f7fa;
}
// 全局滚动条样式
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}
::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
  &:hover {
    background: #a8a8a8;
  }
}
</style>
